(function () {
  'use strict';

  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.cart ? e.detail.cart.item_count : 0;
    document.querySelectorAll('.marla-cart-count').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('#marla-pdp-form, #marla-sd-form')) return;

    e.preventDefault();
    e.stopPropagation();

    var ringSizeSelect = form.querySelector('select[name="properties[Ring Size]"]');
    if (ringSizeSelect && !ringSizeSelect.value) {
      ringSizeSelect.setCustomValidity('Please select a ring size.');
      form.reportValidity();
      ringSizeSelect.setCustomValidity('');
      return;
    }

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) {
          throw new Error(err.description || 'Could not add to bag.');
        });
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .catch(function (err) {
        alert(err.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }, true);

})();
